import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import type { getResveCancelListForm, getResveGolfParkSearchRequest, getResveListForm, getResveTimeDetailGolfParkForm, getResveTimeListGolfParkForm } from "../dto/request/resve.request";
import { getResveCancelDetail, getResveCancelList, getResveDetail, getResveGolfParkSearch, getResveList, getResveTimeDetailGolfPark, getResveTimeGolfPark } from "../v1/resve.service";

/** 예약 목록 조회 */
export const useGetResveList = (form: Omit<getResveListForm, "page" | "pageSize">) => infiniteQueryOptions({
  queryKey: ["resve-list", form],
  queryFn: ({ pageParam = 1 }) => getResveList({...form, page: pageParam, pageSize: 10}),
  retry: 1,
  initialPageParam: 1,
  getNextPageParam: (lastPage, pages) => {
    const fetchedItemsCount = lastPage.data?.resveList?.length ?? 0;
    if (fetchedItemsCount < 10) {
      return undefined;
    }

    return pages.length + 1;
  },
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
});

/** 예약 취소 목록 조회 */
export const useGetResveCancelList = (form: Omit<getResveCancelListForm, "page" | "pageSize">) => infiniteQueryOptions({
  queryKey: ["resve-cancel-list", form], 
  queryFn: ({ pageParam = 1 }) => getResveCancelList({...form, page: pageParam, pageSize: 10}),
  retry: 1,
  initialPageParam: 1,
  getNextPageParam: (lastPage, pages) => {
    const fetchedItemsCount = lastPage.data?.myResveCancelList?.length ?? 0;
    if (fetchedItemsCount < 10) {
      return undefined;
    }

    return pages.length + 1;
  },
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
});

/** 예약 상세 조회 */
export const useGetResveDetail = (id: string | number) => queryOptions({
  queryKey: ["resve-detail", id],
  queryFn: () => getResveDetail(id),
  retry: 1
})

/** 예약 상세 조회 */
export const useGetResveCancelDetail = (id: string | number) => queryOptions({
  queryKey: ["resve-cancel-detail", id],
  queryFn: () => getResveCancelDetail(id),
  retry: 1
})

/** 예약 골프장 검색 */
export const useGetResveGolfParkSearch = (form: getResveGolfParkSearchRequest) => infiniteQueryOptions({
  queryKey: ["resve-golfpark", form],
  queryFn: ({ pageParam }) => getResveGolfParkSearch({...form, page: pageParam, pageSize: 10}),
  retry: 1,
  initialPageParam: 1,
  getNextPageParam: (lastPage, pages) => {
    const fetchedItemsCount = lastPage.data.golfParkList.length || 0;
    if (fetchedItemsCount < 10) {
      return undefined;
    }

    return pages.length + 1;
  },
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
});

/** 예약 타임라인 목록 조회 */
export const useGetResveTimeList = (form: getResveTimeListGolfParkForm) => queryOptions({
  queryKey: ["resve-time-list", form],
  queryFn: () => getResveTimeGolfPark(form),
  retry: 1
})

/** 예약 타임라인 상세 조회 */
export const useGetResveTimeDetail = (form: getResveTimeDetailGolfParkForm) => queryOptions({
  queryKey: ["resve-time-detail", form],
  queryFn: () => getResveTimeDetailGolfPark(form),
  retry: 1
})
